<div
  class="h-100 w-100 d-flex align-items-center justify-content-center"
  [ngClass]="pointWhite ? 'div-point-white' : 'div-point-green'"
>
  <span [ngClass]="pointWhite ? 'point-white' : 'point-green'"></span>
  <span [ngClass]="pointWhite ? 'point-white' : 'point-green'"></span>
  <span [ngClass]="pointWhite ? 'point-white' : 'point-green'"></span>
</div>
